import CryptoJS from 'crypto-js';
const NODE_ENV = process.env.REACT_APP_ENV;
const envConfig = process.env.NODE_ENV === 'development' ? 'test' : NODE_ENV; // 开发环境  和  发布环境

// 【腾讯文档】996SDK服务端接入文档
// https://docs.qq.com/doc/DS1ZmWnZzd3FQWWNB
// https://axhub.im/ax9/302200a9f50cc6bf/#id=wg37al&p=%E7%9B%92%E5%AD%90pc%E6%8E%A5%E5%85%A5%E7%BB%9F%E8%AE%A1%E5%88%86%E6%9E%90%E9%9C%80%E6%B1%82%E6%95%B4%E7%90%86&g=1
// 【腾讯文档】盒子PC埋点需求
// https://docs.qq.com/sheet/DYkpZWVVQUVBtT2tR?tab=BB08J2

let Information = {};
const sdk_ver = '1.0.10';
const SDK_EVENTS_URL = '//log.tj.996sdk.com/v1/events';

// 暂时固定sdk信息
let sdk_app_id = '';
let sdk_app_key = '';
let sdk_url = '//log.tj.996sdk.com/v1/event';
// test
if (envConfig === 'test') {
  sdk_app_id = 'GAjWNTqNpOVx';
  sdk_app_key = '735f61ca52b75dc11a264405b331081c';
} else if (envConfig === 'pre') {
  sdk_app_id = 'nkj62TR8KjX4';
  sdk_app_key = '25ebf1b2094da4d1b74abf7e575faed4';
} else if (envConfig === 'production') {
  sdk_app_id = 'yAeOlBTx4JQg';
  sdk_app_key = '2bacba2daddbaada0bcef1fb4a132edd';
}

if (localStorage.getItem('deviceIdEle')) {
  Information.id = localStorage.getItem('deviceIdEle');
}

export const sdkConfig = {
  sdk_app_id,
  sdk_app_key
};

window.addEventListener('error', function (e) {
  console.log(e);
  console.log(e.target);
});
/**
 * 埋点上报
 * 2023-02-02
 *
 */
if (!sdk_app_id && !sdk_app_key) {
  Y();
}
/**
 * 判断否是IOS还是安卓
 * @type {null}
 */
function Y() {
  let isAndroid = null;
  let isIOS = null;
  var u = navigator.userAgent;
  isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (isAndroid) {
    console.log('安卓');
  } else if (isIOS) {
    if (window.webkit) {
      window.webkit.messageHandlers.getIDFA.postMessage('Javascript invoke OC');
      window.IOSInformation = IOSInformation;
    }
  } else {
    // pc box device id
    if (Window.deviceID) {
      Information.id = Window.deviceID;
    }
  }
  function IOSInformation(res) {
    Information = JSON.parse(res);
  }
}

function getBoxAppVersion() {
  const appv = localStorage.getItem('appv');
  if (!appv) return '0.0.1';
  return appv;
}

function getBoxChannel() {
  return localStorage.getItem('channel') || '996box_pc';
}

/**
 * 埋点
 * @type {burying} 方法名收
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Burying(key) {
    console.log('uuid()', uuid());
    let burying = JSON.stringify({
      appid: sdk_app_id,
      sdk_ver: sdk_ver,
      app_ver: getBoxAppVersion(),
      channel: getBoxChannel(),
      boxid: key.boxid || '',
      device: {
        type: Information.type || 'pc',
        model: Information.model || isMobile(),
        id: Information.id || uuid(),
        id1: '',
        id2: '',
        id3: '',
        os: Information.os || browserRedirect(),
        width: window.innerWidth,
        height: window.innerHeight,
        lang: Information.lang || navigator.language,
        idfv: Information.idfv || ''
      },
      net_type: Information.net_type || getNetworkType(),
      user: {
        id: String(key.uid)
      },
      event: {
        time: (Date.now() / 1000) | 0,
        name: key.eventname,
        type: key.eventtype
      },
      properities: { resource: 'pc', ...key.properities }
    });
    let headers = objKeySort(burying);
    localStorage.setItem(
      'SDK-INFO',
      JSON.stringify({ ...JSON.parse(burying), sdk_app_key, 'x-996sdk-nonce': headers['x-996sdk-nonce'], sdk_url })
    );
    ajax('post', sdk_url, burying, headers);
    // ajax('post', '//log-pre.tj.996Sdk.com/v1/event', burying, headers); // pre
    // ajax('post', '//track-test.tj.996sdk.com/v1/event', burying, headers); // test
    // ajax('post', '//log.tj.996sdk.com/v1/event', burying, headers); //正式
    return burying;
  },
  //let data = {"net_type":"WIFI","app_ver":"SDKDemo1.0.0","appid":"ZykOLEtM3jav","channel":"123","sdk_ver":"1.2.2","device":{"type":"android","model":"HONOR:FNE-AN00","id1":"","id2":"f2eced5e3d7a124b","id3":"ca127fac-bba1-4657-94fa-3ac2c6bdfb1b","os":"12","width":"1080","height":"2316","lang":"zh","id":"ca127fac-bba1-4657-94fa-3ac2c6bdfb1b","net_type":"WIFI"}}
  Escalation() {
    let data = {
      net_type: '' || getNetworkType(),
      app_ver: getBoxAppVersion(),
      appid: sdk_app_id,
      channel: getBoxChannel(),
      sdk_ver: sdk_ver,
      device: {
        type: Information.type || 'pc',
        model: Information.model || isMobile(),
        id: Information.id || uuid(),
        id1: '',
        id2: '',
        id3: '',
        os: Information.os || browserRedirect(),
        width: window.innerWidth,
        height: window.innerHeight,
        lang: Information.lang || navigator.language,
        net_type: Information.net_type || getNetworkType(),
        idfv: Information.idfv || ''
      }
    };
    // return JSON.stringify(encodeURIComponent(data))
    return encodeURIComponent(JSON.stringify(data));
  },
  config: {
    sdkAppid: sdk_app_id,
    sdkAppkey: sdk_app_key,
    sdkChannel: '996box_pc',
    sdk_source: '996盒子'
  },
  Assemble(data) {
    console.log('uuid()', uuid());
    let params = JSON.stringify({
      amount: data.amount || 0, // require
      appId: sdk_app_id,
      boxid: data.boxid,
      deviceModel: Information.model || isMobile(),
      height: window.innerHeight,
      id: Information.id || uuid(),
      id1: '',
      id2: '',
      id3: '',
      jobId: data.jobId,
      jobName: data.jobName,
      lang: Information.lang || navigator.language,
      netType: Information.net_type || getNetworkType(),
      oaIdVer: '',
      orderId: data.orderId, // require
      os: Information.os || browserRedirect(),
      payWay: data.payWay, // need know  // require
      prodId: data.prodId,
      prodName: data.prodName,
      roleId: data.roleId,
      roleLevel: data.roleLevel || 0,
      roleName: data.roleName,
      sdkVer: sdk_ver,
      serverId: data.serverId || '996box', // require
      serverName: data.serverName,
      ua: navigator.userAgent,
      width: window.innerWidth
    });
    // console.log(JSON.parse(params));
    return JSON.parse(params);
  },
  /**
   * 批量上报
   */
  Buryings({ name, type, userId, params }) {
    const appInfo = {
      appid: sdk_app_id,
      sdk_ver: sdk_ver,
      app_ver: getBoxAppVersion(),
      channel: getBoxChannel()
    };

    const device = {
      type: Information.type || 'pc',
      model: Information.model || isMobile(),
      id: Information.id || uuid(),
      os: Information.os || browserRedirect(),
      width: window.innerWidth,
      height: window.innerHeight,
      lang: Information.lang || navigator.language,
      idfv: Information.idfv || ''
    };

    const netType = Information.net_type || getNetworkType();

    const user = {
      id: String(userId)
    };

    const event = {
      time: (Date.now() / 1000) | 0,
      name,
      type
    };

    const properitiesBaseInfo = {
      resource: 'pc',
      user_id: userId
    };

    const eventList = params.map(item => ({
      ...appInfo,
      boxid: item.boxid || '',
      device,
      net_type: netType,
      user,
      event,
      properities: { ...properitiesBaseInfo, ...item }
    }));

    let eventBody = JSON.stringify(eventList);

    ajax('post', SDK_EVENTS_URL, eventBody, objKeySort(eventBody, '/v1/events'));
  }
};
/**
 * 判断是否是浏览器
 */
function isMobile() {
  var u = navigator.userAgent;
  if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
    //安卓手机
    console.log('安卓手机');
    return 'Android';
  } else if (u.indexOf('iPhone') > -1) {
    //苹果手机
    console.log('苹果手机');
    return 'IOS';
  } else if (u.indexOf('Windows Phone') > -1) {
    //winphone手机
    console.log('winphone手机');
    return 'Winphone';
  } else {
    return 'pc';
  }
}
/**
 * UUID
 * 如果是浏览器或者是电脑用户就用本方法
 */
function uuid() {
  let uuid996 = localStorage.getItem('uuid996' + sdk_app_key);
  let i = '';
  if (uuid996 == null) {
    i = guid();
    localStorage.setItem('uuid996' + sdk_app_key, i);
  } else {
    i = uuid996;
  }
  return i;
}
function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
/**
 * 取当前操作系统
 */
function browserRedirect() {
  var sUserAgent = navigator.userAgent;
  var isWin = navigator.platform === 'Win32' || navigator.platform === 'Windows';
  var isMac =
    navigator.platform === 'Mac68K' ||
    navigator.platform === 'MacPPC' ||
    navigator.platform === 'Macintosh' ||
    navigator.platform === 'MacIntel';
  if (isMac) return 'Mac';
  var isUnix = navigator.platform === 'X11' && !isWin && !isMac;
  if (isUnix) return 'Unix';
  var isLinux = String(navigator.platform).indexOf('Linux') > -1;
  if (isLinux) return 'Linux';
  if (isWin) {
    var isWin2K = sUserAgent.indexOf('Windows NT 5.0') > -1 || sUserAgent.indexOf('Windows 2000') > -1;
    if (isWin2K) return 'Win2000';
    var isWinXP = sUserAgent.indexOf('Windows NT 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1;
    if (isWinXP) return 'WinXP';
    var isWin2003 = sUserAgent.indexOf('Windows NT 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1;
    if (isWin2003) return 'Win2003';
    var isWinVista = sUserAgent.indexOf('Windows NT 6.0') > -1 || sUserAgent.indexOf('Windows Vista') > -1;
    if (isWinVista) return 'WinVista';
    var isWin7 = sUserAgent.indexOf('Windows NT 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1;
    if (isWin7) return 'Win7';
    var isWin10 = sUserAgent.indexOf('Windows NT 10') > -1 || sUserAgent.indexOf('Windows 10') > -1;
    if (isWin10) return 'Win10';
    var isWin11 = sUserAgent.indexOf('Windows NT 11') > -1 || sUserAgent.indexOf('Windows 11') > -1;
    if (isWin11) return 'Win11';
  }
  return 'other';
}
/**
 * 取网络类型
 */
function getNetworkType() {
  var ua = navigator.userAgent;
  var networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other';
  networkStr = networkStr.toLowerCase().replace('nettype/', '');
  var networkType;
  switch (networkStr) {
    case 'wifi':
      networkType = 'wifi';
      break;
    case '5g':
      networkType = '5G';
      break;
    case '4g':
      networkType = '4G';
      break;
    case '3g':
      networkType = '3G';
      break;
    case '3gnet':
      networkType = '3G';
      break;
    case '2g':
      networkType = '2G';
      break;
    default:
      networkType = 'UNKNOWN';
  }
  return networkType;
}
/**
 * 封装ajax
 * @param method:请求的方式get还是post
 * @param url:请求的地址
 * @param params:发送的参数
 * @callback 返回响应调用的函数
 * */
function ajax(method, url, params, header) {
  var xhr = new XMLHttpRequest();
  xhr.open(method, url);
  Object.keys(header).forEach(key => {
    xhr.setRequestHeader(key, header[key]);
  });
  if (method.toLowerCase() === 'get') {
    //判断请求方式
    xhr.send(params);
  } else {
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(params);
  }
  xhr.onreadystatechange = () => {
    if (xhr.readyState === 4 && xhr.status === 200) {
      // console.log(xhr.responseText);
    }
  };
}

/**
 * 随机16位
 * @returns {string}
 */
function getRamNumber() {
  var result = '';
  for (var i = 0; i < 16; i++) {
    result += Math.floor(Math.random() * 16).toString(16); //获取0-15并通过toString转16进制
  }

  //默认字母小写，手动转大写
  return result.toUpperCase(); //另toLowerCase()转小写
}
// 签名排序
function objKeySort(body, api) {
  //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  let headers = {
    'x-996sdk-appid': sdk_app_id,
    'x-996sdk-algo': 'MD5',
    'x-996sdk-nonce': getRamNumber(),
    'x-996sdk-timestamp': (Date.now() / 1000) | 0
  };
  let xargs = ['POST', api || '/v1/event'];
  Object.keys(headers)
    .sort()
    .forEach(key => {
      xargs.push(key + '=' + headers[key]);
    });
  xargs.push(body);
  xargs.push('key=' + sdk_app_key);
  headers['x-996sdk-sign'] = CryptoJS.MD5(xargs.join('\n')).toString();
  return headers;
}
